import { Link } from 'react-router-dom';
import { X, ArrowRight, Scale } from 'lucide-react';
import { useCompare } from '@/context/CompareContext';

export default function CompareBar() {
  const { compareList, removeFromCompare, clearCompare } = useCompare();

  if (compareList.length === 0) {
    return null;
  }

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-[#1a1a1a] text-white z-50 shadow-2xl border-t-4 border-[#ff3b00] animate-slideUp"
      data-testid="compare-bar"
    >
      <div className="max-w-5xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          {/* Left: Selected garages */}
          <div className="flex items-center gap-3 flex-1 overflow-x-auto">
            <div className="flex items-center gap-2 text-sm text-white/70 whitespace-nowrap">
              <Scale className="w-5 h-5 text-[#ff3b00]" />
              <span>Σύγκριση ({compareList.length}/3):</span>
            </div>
            
            <div className="flex items-center gap-2">
              {compareList.map((garage) => (
                <div 
                  key={garage.garage_id}
                  className="flex items-center gap-2 bg-white/10 rounded-full pl-3 pr-1 py-1"
                >
                  <span className="text-sm font-medium truncate max-w-[120px]">
                    {garage.name}
                  </span>
                  <button
                    onClick={() => removeFromCompare(garage.garage_id)}
                    className="p-1 hover:bg-white/20 rounded-full transition-colors"
                    aria-label={`Αφαίρεση ${garage.name}`}
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
              ))}
              
              {/* Empty slots */}
              {Array.from({ length: 3 - compareList.length }).map((_, i) => (
                <div 
                  key={`empty-${i}`}
                  className="w-24 h-8 border border-dashed border-white/30 rounded-full flex items-center justify-center"
                >
                  <span className="text-xs text-white/40">+ Πρόσθεσε</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Actions */}
          <div className="flex items-center gap-3 shrink-0">
            <button
              onClick={clearCompare}
              className="text-sm text-white/60 hover:text-white transition-colors"
            >
              Καθαρισμός
            </button>
            
            <Link
              to="/compare"
              className={`flex items-center gap-2 px-5 py-2 rounded-full font-semibold transition-all ${
                compareList.length >= 2
                  ? 'bg-[#ff3b00] hover:bg-[#cc2f00] text-white'
                  : 'bg-white/20 text-white/50 cursor-not-allowed pointer-events-none'
              }`}
              data-testid="compare-button"
            >
              <span>Σύγκρινε</span>
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); }
          to { transform: translateY(0); }
        }
        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }
      `}</style>
    </div>
  );
}
